<template>
  <v-container fluid fill-height>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card elevation="0">
          <v-card
            class="pa-2 d-flex justify-space-between align-center"
            v-if="url_code"
          >
            <span class="text-caption">{{ url_code }}</span>
            <div>
              <v-btn
                class="mr-3"
                icon
                x-small
                color="blue"
                @click="copyToClipboard"
              >
                <v-icon v-if="!copied">mdi-content-copy</v-icon>
                <v-icon v-else color="green">mdi-check</v-icon>
              </v-btn>
              <v-btn icon x-small color="red" @click="openInNewTab">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </div>
          </v-card>

          <!-- Form Section -->
          <v-card-text class="px-0 mt-3">
            <v-autocomplete
              v-model="form.partner"
              :items="partners"
              item-text="name"
              item-value="code"
              label="Partner*"
              outlined
              dense
              hide-details="auto"
              @change="getBranches()"
              return-object
              clearable
            ></v-autocomplete>
           <!--  <v-select
              v-model="form.partner_branch"
              :items="branches"
              item-text="name"
              item-value="code"
              label="Partner Branch"
              :disabled="form.partner == null"
              outlined
              dense
              hide-details="auto"
              return-object
            ></v-select> -->
          </v-card-text>

          <!-- Actions -->
          <v-card-actions class="pt-0 pr-0">
            <v-spacer></v-spacer>
            <v-btn class="accent white--text ml-2" @click="reset()"
              >Reset</v-btn
            >
            <v-btn class="accent white--text ml-2" @click="generateEncodedUrl()"
              >Generate URL</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import formDialog from "@/components/degree/form.vue";
import searchBar from "@/components/searchBar.vue";
import env from "@/helpers/env";
export default {
  components: {
    formDialog,
    searchBar,
  },
  data() {
    return {
      env: env,
      copied: false,
      form: {
        partner: null,
        partner_branch: null,
      },
      branches: [],
      partners: [],
      url_code: null,
    };
  },
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Partner URL" }]);
    this.getPartners();
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard
        .writeText(this.url_code)
        .then(() => {
          this.copied = true;
          setTimeout(() => (this.copied = false), 2000);
        })
        .catch((err) => {
          console.error("Failed to copy:", err);
        });
    },
    async getPartners() {
      await this.$axios
        .get("partners")
        .then((res) => {
          this.partners = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getBranches() {
      let params = {};
      if (this.form.partner?.id) params.partner_id = this.form.partner.id;

      if (this.form.partner.id)
        await this.$axios
          .get("partner_branches", { params })
          .then((res) => {
            this.branches = res.data.data;
          })
          .catch(async (error) => {
            this.$store.commit("showSnackbar", {
              message: error.response.data.message,
              color: "error",
            });
          });
    },
    async generateEncodedUrl() {
      let map = {
        partner_code: this.form.partner?.code,
        partner_branch_code: this.form.partner_branch?.code,
      };

      await this.$axios
        .get("generate_encoded_url", { params: map })
        .then((res) => {
          this.url_code = `${this.env.partner_url}${res.data.data}`;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    openInNewTab() {
      window.open(this.url_code, "_blank");
    },
    reset() {
      this.form = {
        partner: null,
        partner_branch: null,
      };
      this.url_code = null;
      this.getPartners();
    },
  },
};
</script>

<style></style>
